import { Components, Theme } from '@mui/material';

const MuiSwitch: Components<Theme>['MuiSwitch'] = {
  styleOverrides: {
    track: {
      borderRadius: '100px',
    },
    thumb: ({ theme }) => ({
      backgroundColor: theme.palette.grey[50],
      '.Mui-checked &': {
        backgroundColor: theme.palette.grey[50],
      },
    }),
    switchBase: {
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          opacity: 1,
        },
      },
      '&.Mui-checked.Mui-disabled': {
        '& + .MuiSwitch-track': {
          opacity: 0.3,
        },
      },
    },
  },
  variants: [
    {
      props: {
        size: 'medium',
      },
      style: ({ theme }) => ({
        width: '64px',
        height: '36px',
        paddingTop: theme.spacing(theme.spacingSizes.xs),
        paddingBottom: theme.spacing(theme.spacingSizes.xs),

        '& .MuiSwitch-thumb': {
          width: '16px',
          height: '16px',
        },

        '& .MuiSwitch-switchBase': {
          padding: '10px 14px',
        },
      }),
    },
  ],
};

export default MuiSwitch;
